import React, { Fragment, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import axios from "services/interceptor/Interceptor";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import FormSection from "../../formSection/formSection";
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ButtonWithIcon from "components/sales/buttons/buttonWithIcon/buttonWithIcon";
import { handleValidateObj } from "constants/objValues/objvalues";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import Inventory from "components/sales/inventory/inventory";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup, Table } from "react-bootstrap";
import FileUpload from "components/sales/fileUpload/fileUpload";
import { imageUploadUrlPublic } from "services/redux/fileUpload/action";
import * as moment from "moment";
import ModalPop from "components/sales/modal/modal";
// import s from "./addAdvance.module.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Config from "services/config/config";
import { Toast } from "bootstrap";
import { showToast } from "services/utils/networks/network";
import AppNotifications from "components/sales/appNotifications/appNotifications";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Images from 'assets/images/imageData';


const ExistingProjectList = ({
    showProjectListPopup,
    onClosePopup = () => { },
    formSubmit = () => { },
    existingProjectList
//   imageUploadUrlPublic,
//   businessId,
//   invoiceId,
//   contractId,
//   siteNumber,
//   businessName,
//   contractType,
//   isEdit = false,
//   rowData = {},
//   isView = false,
}) => {
  /* const [inputList, setInputList] = useState([
    {
      installation_amt: isEdit ? rowData?.installation_amount : "",
      rental_charge: isEdit ? rowData?.rental_amount : "0",
      tag_charge: isEdit ? rowData?.tag_amount : "",
      payment_mode: isEdit ? rowData?.payment_mode : "",
      reference_number: isEdit ? rowData?.payment_reference : "",
      tds_check: isEdit ? (rowData?.tds === 0 ? "No" : "Yes") : "",
      tds_amt: isEdit ? rowData?.tds : "",
      remark: isEdit ? rowData?.remarks : isView ? rowData?.finance_remarks : '',
      payment_photo: "",
      adv_payment_date: isEdit ? rowData?.transaction_date : "",
      status: isEdit ? rowData?.status : "",
      bank: isEdit ? rowData?.bank : "",
      trans_amount: isEdit ? rowData?.amount : "",
      capex_charge:  isEdit ? rowData?.capex_amount : "0",
    },
  ]); */
    
  const { baseUrl } = useContext(BaseUrl);
    const [details, setDetails] = useState(null);
    useEffect(() => {
        console.log(existingProjectList);
        if (existingProjectList) {
          setDetails(existingProjectList);
        }
      }, [existingProjectList]);

  const handleSubmit = () => {
    onClosePopup();
  }

  return (
    <>
      <ModalPop
        title={"Existing Projects"}
        show={showProjectListPopup}
        handleModalHide={() => {onClosePopup();}}
      >
        <Fragment>
            {details &&
            Object.keys(details).length !== 0 && (
                <div className="panel-card">
                <div className="panel-heading">List of existing projects accroding to your search.</div>
                <div className="panel-body">
                    <div className="details-list">
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>Project Id</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Pincode</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {details &&
                            details &&
                            details.map((val) => {
                            return (
                                <tr>
                                <td>{val.project_id}</td>
                                <td>{val.project_name}</td>
                                <td>{val.address}</td>
                                <td>{val.city}</td>
                                <td>{val.state}</td>
                                <td>{val.pincode}</td>
                                <td>{val?.lead_id && <a href={`${baseUrl}/contract-sales-listing/` + val.lead_id}>View Contracts</a>}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                    </Table>
                    </div>
                </div>
                </div>
            )}
            
        </Fragment>
        <Button onClick={handleSubmit()} className="btn btn-primary">
          {localization.addNewProject}
        </Button>
      </ModalPop>
    </>
  );
};
ExistingProjectList.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      imageUploadUrlPublic,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ExistingProjectList);
